import { Link } from 'react-router-dom';

export default function WhatIsSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24 px-4 md:px-10">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-800 rounded-full text-xs font-semibold uppercase tracking-wide mb-4">
            Educational Resource
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            What Is <span className="italic text-primary-500">Superbuy Spreadsheet</span>?
          </h2>
          <p className="mt-5 text-foreground-600 text-base md:text-lg max-w-3xl mx-auto leading-relaxed">
            Superbuy Spreadsheet is a structured product research resource that helps shoppers organize product information, compare options, review important details, and discover useful shopping opportunities. Instead of searching through hundreds of pages manually, users can explore organized spreadsheets designed for faster product discovery.
          </p>
        </div>

        {/* Feature Table */}
        <div className="overflow-hidden rounded-2xl border border-background-200/70">
          <table className="w-full text-left">
            <thead>
              <tr className="bg-foreground-950 text-background-50">
                <th className="px-6 py-4 text-sm font-semibold">Feature</th>
                <th className="px-6 py-4 text-sm font-semibold">Traditional Search</th>
                <th className="px-6 py-4 text-sm font-semibold bg-accent-500 text-foreground-950">Superbuy Spreadsheet</th>
              </tr>
            </thead>
            <tbody>
              {[
                { feature: 'Product Discovery', traditional: 'Slow', superbuy: 'Fast' },
                { feature: 'Organization', traditional: 'Limited', superbuy: 'Structured' },
                { feature: 'Comparison', traditional: 'Difficult', superbuy: 'Easy' },
                { feature: 'Research Time', traditional: 'High', superbuy: 'Reduced' },
                { feature: 'Category Browsing', traditional: 'Manual', superbuy: 'Organized' },
              ].map((row, i) => (
                <tr key={row.feature} className={i % 2 === 0 ? 'bg-background-50' : 'bg-background-100'}>
                  <td className="px-6 py-4 text-sm font-semibold text-foreground-900">{row.feature}</td>
                  <td className="px-6 py-4 text-sm text-foreground-500">{row.traditional}</td>
                  <td className="px-6 py-4 text-sm font-semibold text-accent-800 bg-accent-50/50">{row.superbuy}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <Link
            to="/superbuy-spreadsheet-complete-guide"
            className="inline-flex items-center gap-2 px-6 py-3 text-foreground-700 hover:text-foreground-950 font-semibold text-sm cursor-pointer transition-colors"
          >
            Read the Complete Guide
            <i className="ri-arrow-right-line text-lg"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}